import { render, staticRenderFns } from "./XYK.vue?vue&type=template&id=4b6ad236&scoped=true&"
import script from "./XYK.vue?vue&type=script&lang=js&"
export * from "./XYK.vue?vue&type=script&lang=js&"
import style0 from "./XYK.vue?vue&type=style&index=0&id=4b6ad236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ad236",
  null
  
)

export default component.exports